import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09baa0e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "window"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = { style: {"position":"relative","display":"inline-table","align-items":"center","margin":"1% auto 0% auto"} }
const _hoisted_5 = {
  id: "tblInputData",
  style: {"border":"none !important","height":"auto","font-size":"0.95em","width":"700px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"150px"} }, "User ID :", -1 /* HOISTED */))
const _hoisted_7 = { style: {"text-align":"left","width":"400px"} }
const _hoisted_8 = {
  rowspan: "3",
  style: {"vertical-align":"top","padding-left":"10px","margin-left":"0%","width":"150px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, "Menu :", -1 /* HOISTED */))
const _hoisted_10 = { style: {"text-align":"left"} }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, "Station Code :", -1 /* HOISTED */))
const _hoisted_13 = { style: {"text-align":"left"} }
const _hoisted_14 = ["value"]
const _hoisted_15 = { style: {"border":"none !important","height":"auto","font-size":"0.95em","width":"600px"} }
const _hoisted_16 = { style: {"width":"100px","text-align":"right"} }
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"100px","padding-left":"0.9rem"} }, " ALL ", -1 /* HOISTED */))
const _hoisted_19 = { style: {"width":"100px","text-align":"right"} }
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"300px","padding-left":"0.9rem"} }, " Recent Approve/Deny By SMC Manager ", -1 /* HOISTED */))
const _hoisted_22 = { style: {"margin":"0% 5% 0% 5%","text-align":"right","font-size":"0.9em","height":"max-content"} }
const _hoisted_23 = { style: {"margin":"0% 2% auto 2%"} }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"divMenuHistoryHeader\" data-v-09baa0e0><table id=\"tblMenuHistoryResult\" data-v-09baa0e0><thead data-v-09baa0e0><tr data-v-09baa0e0><th style=\"width:5%;\" data-v-09baa0e0>User ID</th><th style=\"width:20%;\" data-v-09baa0e0>User Name</th><th style=\"width:5%;\" data-v-09baa0e0>Applyer</th><th style=\"width:9%;\" data-v-09baa0e0>Node Manager Approver</th><th style=\"width:9%;\" data-v-09baa0e0>SMC Manager Approver</th><th style=\"width:25%;\" data-v-09baa0e0>Status</th><th style=\"width:17%;\" data-v-09baa0e0>Process Date</th><th style=\"width:10%;\" data-v-09baa0e0>Cancel</th></tr></thead></table></div>", 1)
const _hoisted_25 = {
  id: "divMenuHistoryBody",
  style: {"overflow":"auto","height":"calc(100vh - 438px)"}
}
const _hoisted_26 = {
  id: "tblMenuHistoryResult",
  class: "w-100"
}
const _hoisted_27 = { id: "tblMenuHistoryBody" }
const _hoisted_28 = { style: {"width":"5%"} }
const _hoisted_29 = { style: {"width":"20%"} }
const _hoisted_30 = { style: {"width":"5%"} }
const _hoisted_31 = { style: {"width":"9%"} }
const _hoisted_32 = { style: {"width":"9%"} }
const _hoisted_33 = { style: {"width":"25%"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("remove by user")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("remove by admin")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("waiting for node manager approval")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("waiting for SMC manager approval")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("approved by node manager for General Function")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("waiting for SMC manager approval after node manager approved")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("denied by node manager")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("approved by SMC")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("denied by SMC")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("revert applying status by SMC")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("remove after stationCode changed")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("remove after department changed")
const _hoisted_46 = { style: {"width":"17%"} }
const _hoisted_47 = { style: {"width":"10%"} }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  style: {"text-align":"center","border":"none","font-size":"1em"}
}, "No Data", -1 /* HOISTED */))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  id: "divPagination",
  class: "div-History-Pagination"
}
const _hoisted_53 = {
  key: 0,
  class: "column1"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Page", -1 /* HOISTED */))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "column1"
}
const _hoisted_57 = {
  key: 2,
  class: "column2"
}
const _hoisted_58 = {
  key: 3,
  class: "column2"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Page", -1 /* HOISTED */))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  class: "modal fade",
  id: "processCancelModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"35%","margin-left":"32.5%"}
}
const _hoisted_62 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-09baa0e0><h4 class=\"modal-title\" id=\"showModalLabel\" data-v-09baa0e0>Cancel Approval Status</h4><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-09baa0e0></button></div><div class=\"modal-body\" id=\"modal-body\" style=\"text-align:left;font-size:16px;\" data-v-09baa0e0><div style=\"height:20%;\" data-v-09baa0e0> Are you sure to revert approval status? </div></div>", 2)
const _hoisted_66 = { class: "modal-footer" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "modalCancel",
  class: "btn btn-secondary",
  style: {"width":"78px","height":"35px","text-align":"center"},
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "userId-txt-form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputUserId) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.inputUserId]
              ])
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btnCommon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goSearchApprovalHistory()))
              }, "Go")
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedMenu) = $event)),
                style: {"padding":"0.375rem 0.75rem","border-radius":"0.25rem","width":"400px"}
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mainMenuList[0], (mCode, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "adjusting-option",
                    key: index,
                    value: mCode.mainMenuCode
                  }, _toDisplayString(mCode.mainMenuCode) + " : " + _toDisplayString(mCode.mainMenuName), 9 /* TEXT, PROPS */, _hoisted_11))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.selectedMenu]
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", _hoisted_13, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedStation) = $event)),
                style: {"padding":"0.375rem 0.75rem","border-radius":"0.25rem","width":"400px"}
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationList[0], (stCode, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "adjusting-option",
                    key: index,
                    value: stCode.stationCode
                  }, _toDisplayString(stCode.stationCode) + " : " + _toDisplayString(stCode.companyName), 9 /* TEXT, PROPS */, _hoisted_14))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.selectedStation]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_15, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_16, [
              _createElementVNode("input", {
                type: "radio",
                id: "rdoAll",
                style: {"display":"inline"},
                name: "byALL",
                value: "0",
                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.rdoCheckChange($event))),
                checked: $setup.selectedMode == '0'
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17)
            ]),
            _hoisted_18,
            _createElementVNode("td", _hoisted_19, [
              _createElementVNode("input", {
                type: "radio",
                id: "rdoRecent",
                style: {"display":"inline"},
                name: "byRecentBySMC",
                value: "1",
                onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.rdoCheckChange($event))),
                checked: $setup.selectedMode == '1'
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20)
            ]),
            _hoisted_21
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_22, " Page " + _toDisplayString($setup.currentPageNo) + " / " + _toDisplayString($setup.pageCount), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("table", _hoisted_26, [
            _createElementVNode("tbody", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.approvalHistoryList, (historyData, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_28, _toDisplayString(historyData.userId_id), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(historyData.userId_id__givenName) + " " + _toDisplayString(historyData.userId_id__familyName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(historyData.applyer), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_31, _toDisplayString(historyData.nodeManager), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(historyData.smcManager), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_33, [
                    (historyData.status == '0' && historyData.applyer == null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_34
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                      : (historyData.status == '0' && historyData.applyer != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_35
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (historyData.status == '1')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _hoisted_36
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          : (historyData.status == '2')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _hoisted_37
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (historyData.status == '3' && historyData.smcManager != null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _hoisted_38
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                              : (historyData.status == '3')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _hoisted_39
                                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                : (historyData.status == '4')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _hoisted_40
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                  : (historyData.status == '5')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                        _hoisted_41
                                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    : (historyData.status == '6')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                          _hoisted_42
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      : (historyData.status == '7')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                            _hoisted_43
                                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        : (historyData.status == '8')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                              _hoisted_44
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                          : (historyData.status == '9')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                                _hoisted_45
                                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_46, _toDisplayString(historyData.processDate), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_47, [
                    (historyData.row_number == '0')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#processCancelModal",
                          class: "btnCommon",
                          onClick: ($event: any) => ($setup.showRevertApprovalModal(historyData))
                        }, " Cancel ", 8 /* PROPS */, _hoisted_48))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.isNoData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_49, _hoisted_51))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        ($setup.isSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              ($setup.currentPageNo == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changeHistoryPage('Back'))),
                      type: "button",
                      class: "btnHistoryDirection"
                    }, _toDisplayString($setup.historyBackBtnText), 1 /* TEXT */)
                  ])),
              ($setup.pageCount > 1 && $setup.currentPageNo < $setup.pageCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changeHistoryPage('Next'))),
                      type: "button",
                      class: "btnHistoryDirection"
                    }, _toDisplayString($setup.historyNextBtnText), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("button", {
              type: "button",
              id: "btnStatusCancel",
              class: "btn btn-primary button-design",
              style: {"width":"78px","height":"35px","text-align":"center"},
              "data-bs-dismiss": "modal",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.cancelApprovalStatus()))
            }, " Revert ")
          ])
        ])
      ])
    ])
  ]))
}